/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SignUpInput = {
    email: string;
    firstName: string;
    lastName: string;
    phone?: string | null;
    title?: string | null;
    companyName?: string | null;
    country?: string | null;
};
export type SignupUserMutationVariables = {
    input: SignUpInput;
};
export type SignupUserMutationResponse = {
    readonly signUp: {
        readonly success: boolean;
        readonly error: string | null;
    };
};
export type SignupUserMutation = {
    readonly response: SignupUserMutationResponse;
    readonly variables: SignupUserMutationVariables;
};



/*
mutation SignupUserMutation(
  $input: SignUpInput!
) {
  signUp(input: $input) {
    success
    error
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUpPayload",
    "kind": "LinkedField",
    "name": "signUp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignupUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignupUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6c9b5fe17dd4c70b3d0feca9ef751b54",
    "id": null,
    "metadata": {},
    "name": "SignupUserMutation",
    "operationKind": "mutation",
    "text": "mutation SignupUserMutation(\n  $input: SignUpInput!\n) {\n  signUp(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cdd37e6510d101626faf73826781a44b';
export default node;
